module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "dl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("March 1985")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("The music throbbed—John Cougar singing about Jack and Diane, drums pounding his point and rattling the windows—and Erin Edwards scanned the smoke-filled room, half hoping to see him, half terrified to see him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Todd Griffith. The cutest guy in school. Classic in every way: dark hair, amber eyes that looked green in the right light, square jaw, great mouth, powerful body. He was beautiful to look at and also athletic, which was the only thing that kept him from being universally coveted at Benson Prep School, since there was a contingent of freaky pothead girls at school who weren’t interested in anyone their parents would approve of.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But the guys were afraid of him, without exception. Which made him even more appealing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No doubt about it. Todd Griffith was perfect.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But Todd wasn’t who Erin was here to see. The guy Erin was really looking for … he’d be with Todd.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Is he here?” her friend Jordan Tyler asked at her elbow. She was thinking Todd because that was who Erin had liked first.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“He’s "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("got")]), _vm._v(" to be.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jordan squinted and scanned the room. “I don’t see him. And I think that’s good because, Erin, he’s kind of a jerk. No offense.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Erin was only half paying attention to Jordan. “Who, Todd?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes, Todd. Who else are we talking about? You went out with him one time three months ago and all he did was try to get into your pants.” Jordan raised an eyebrow. “Then he told everyone you gave him a blow job. I don’t know how you can stand him after that.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Erin nodded. “But I’m not "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("sure")]), _vm._v(" he said that. That’s just what David Rutley said, and "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("he’s")]), _vm._v(" a jerk.” There was no denying that David Rutley was a jerk, but she did half wonder why Todd hadn’t set the record straight if he really hadn’t said it. All the guys were cowed by him, it would have been nothing for him to just tell them to lay off. They would have fallen in line like baby ducks, just like they did anytime he said anything else.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Okay.…” Jordan looked dubious. “Whatever. Oh!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Erin turned, startled. “What?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jordan frowned. “Well.” She pointed. “Todd’s here.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sure enough, he was. Along with a group of guys, including David Rutley and a couple of others Erin didn’t recognize, as well as a sleazy-looking girl with dark hair, teased high and sprayed into a style that made her look like a Mafia girlfriend.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The girl wasn’t even pretty. It was so obvious what he wanted from her. She was rounded, with huge boobs and a big butt, and a big round face that he probably put up with to get the rest. Without even talking to her, Erin knew her type, knew exactly what kind of girl she was.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But that’s what Todd was all about. She’d known it ever since she’d heard the rumors of her blowing him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She was over him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Maybe he’d have better luck with this girl.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Wow, who’s the slut?” Jordan whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Just his type,” Erin said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Aren’t you glad you didn’t do anything more than kiss him?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes.” Erin wasn’t interested in playing that game. She suspected—or hoped, anyway—the other guy wasn’t like that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Unfortunately, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("he")]), _vm._v(" didn’t seem to be here.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Are you going to say something to him?” Jordan asked, indicating Todd and his date.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Erin shook her head. “No point.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jordan nodded like she understood. But she didn’t. Not yet. “Good call. Do you want a beer?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Normally she wouldn’t. Erin hated beer. But she and Jordan had a ride home with Jordan’s older sister, who was at the movies until after midnight, so it wasn’t like Erin’s mom was going to smell it on her breath before she got to brush her teeth. Plus she wouldn’t mind having a little liquid courage in order to socialize with all these people.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes,” she said. It was going to be a dull party after all. “Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jordan gave her a pat on the shoulder and headed for the keg, leaving a waft of J"), _c('span', {
    staticClass: "epub-font"
  }, [_vm._v("ō")]), _vm._v("van musk trailing behind her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Somebody’s Baby” by Jackson Browne came over the speakers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That’s when Erin saw him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Him")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The one she’d been hoping to see.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Todd’s best friend.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She knew who he was because he’d come to baseball games now and then when Todd was playing and she’d asked someone about him. The story was that he was a fighter, mean as a snake and twice as aggressive as Todd, but he looked mild and sweet to Erin.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Which itself was intriguing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They’d grown up together, they were practically brothers. They even kind of looked alike, only his build was slighter, his hair lighter, his overall look just a little less immediately striking. But he had amazing eyes. Large and kind. The sort of eyes that made people toss around terms like "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("old soul")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She found him both compelling and disconcerting at the same time. From the first time she’d seen him, his image had been emblazoned on her mind, and when he stepped into view it was as if her mind closed over it like a trap. She didn’t "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("want")]), _vm._v(" to think about him, but she couldn’t stop.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His eyes met hers and something clicked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She backed away involuntarily, knocking into a warm body.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Er"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("in")]), _vm._v("!” It was Jordan, holding two opaque plastic cups of beer. There was quite a bit of it on her sweater now too.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m sorry!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jordan touched the large wet spot on her top. “Oh, my God, I’m going to reek now!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Go rinse really quick,” Erin said. “It won’t be any wetter than the beer, but then it won’t stink. Come on, I’ll wear your shirt and you can wear mine since it’s dry.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No, that’s too much trouble.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It’s not that big a deal. Really.” Erin imagined she could feel his eyes on her back and all of her systems were running on high. She had to run away or she was going to run right to him and everyone would think she was a psychopath. “Let’s go.” She led Jordan to the bathroom and closed the door behind them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jordan pulled off her sweater and started rinsing the spot in the sink. “What’s going on? Who are you hiding from?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No one.” Erin pulled her shirt off and waited for Jordan to hand over the wet sweater. “Todd’s friend.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Todd’s "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("friend")]), _vm._v("?” She wrung out her sweater and handed it to Erin, taking the shirt. “Which one?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You don’t know him.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What are you talking about? "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("I")]), _vm._v(" don’t know him but you "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("do")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No. But.” But what? She felt like she did? That sounded stupid. Something about him made her want to run to him and away from him in equal measure. “He’s Todd’s best friend, so…”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jordan nodded sagely as she strained to pull the buttons together across her chest. “So stay the fuck away.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yeah.” Erin thought about his eyes and her breath quickened. “Far away.” She dabbed at the sweater she was now wearing with a dry hand towel to blot the excess moisture.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They grabbed their beers and returned to the party, where Erin spent the next fifteen minutes straining to find him again in the crowded haze but didn’t see him. She downed her beer and went to refill it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When she turned around, he was right there.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Oh!” She laid a hand to her chest.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The song changed abruptly to “Dreams” by Fleetwood Mac.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He looked at her directly. “Hi.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Good teeth, she noted. That was important. Straight. White. Masculine. Not like Paul Dyson in her math class, who looked like he still had his baby teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Hi.” She gave a flustered smile. It was instantly obvious that she wasn’t going to be able to play this cool. “I … I’m sorry, I don’t know your name…?” Did that sound even "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("remotely")]), _vm._v(" true?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Nate Lawson.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m Erin.” She drank some beer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He smiled. “I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“How do you— Oh.” He’d been there the night she was with Todd on that one date. She was reasonably sure she’d been a topic of some conversation after they’d dropped her off, though she was equally sure the accuracy of that conversation was low. “You’re Todd’s friend, right?” Arrgh! Stupid "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("again")]), _vm._v(". She sounded like she was trying to sound "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("so")]), _vm._v(" casual that he’d have to be blind not to see right through it!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Right.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Silence stretched between them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You don’t go to Benson,” she pointed out. Like there was any question as to whether or not she’d know him in a school of just over a hundred students.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He shook his head. “I go to Churchill.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Hm.” She nodded, as if that were something worth mulling over. “Are you here with someone?” she asked, suddenly self-conscious that she sounded both hyperactive and overinterested.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Her mouth was dry, so she drank more beer. It tasted terrible.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She didn’t care, she drained it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He looked at her curiously. “No. Well, with them.” He indicated Todd and their friends.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She looked, as if she didn’t know who he meant. She was getting a little light-headed. “Oh. Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("What was it about this guy that made her "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("so")]), _vm._v(" uncool?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Have you known Todd long?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Since first grade. We went to school together, played on the same baseball team … you name it. We’ve known each other forever.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She nodded, unsure what to say to that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He looked at her empty cup. “Do you want another beer?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She looked at the cup too, like it was surprising to find it empty. “Sure. Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He reached for it, lightly brushing her fingers with his hand, and took it over to the keg. She waited, standing awkwardly in the one spot, her heart pounding stupidly. He returned shortly and handed her the full cup. She noticed he had gotten one for himself too. “So who are you here with?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“My friend Jordan. She’s—” She looked around to point her out. “Suddenly not here.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I think I saw her with you when I came in.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Probably.” He’d noticed her when he came in? That was good. Wasn’t it? It’s not like she was being loud and sloppy and calling attention to herself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Someone turned up the music. Billy Joel’s “Only the Good Die Young.” Erin hoped to God he didn’t ask her to dance. Of the many things she was not good at, dancing was at the very top of the list.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So naturally the next thing she heard from him sounded like him asking her to dance.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Oh, I’m sorry,” she said, shaking her head, feeling the heat rise in her face. “I’m not really into that.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He looked at her quizzically.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She’d made a mistake. Clearly. “I’m sorry, I must have misunderstood. What did you say?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This time it sounded like, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Are you almost done?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Done?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Done with what? Was she supposed to be doing something?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Done with what?” She leaned in closer and felt a buzz of energy sizzle between them. She could smell the leather of his coat, which he hadn’t taken off.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I asked if you were having fun.” Wow, he had a nice voice, now that she could actually hear him. Really husky and low. Sexy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Oh.” She relaxed fractionally. “Yes!” That sounded too eager. “I guess. Are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Now.” He held her gaze for a minute, then his face colored a little and he looked away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That’s when she got it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He was nervous talking to "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("her")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Suddenly she felt a little braver. “Do you want to go outside and talk?” she asked, like she was the kind of girl who was comfortable suggesting that sort of thing. In truth, she was kind of desperate to get away from the noise and smoke and the embarrassment of repeatedly asking, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("What")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Cool.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He signaled Todd, who looked from him to Erin and then back at Nate with a funny look she couldn’t quite read.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“He’s competitive,” Nate said, in answer to her unasked question. “You’re part of his domain.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“But I’m not!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nate laughed. “Don’t worry about it. That’s just Todd.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She could believe it. Todd was exactly the sort to only be interested in her if she was interested in his friend. God knows he hadn’t demonstrated any interest in her after their one and only “date.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She led Nate to the front door, stopping to grab her pitifully thin jacket from the back of a chair on the way. It was going to be little protection against the elements, particularly since she was wearing a wet sweater. As soon as she stepped outside, she was cold. Really cold. Their breath came out in icy white clouds. It was frigid even for a February night.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’m going to die,” she announced on a quivering white puff of breath. The wind lifted and blew her hair across her face in ghostly pale strands. She pushed it back and sniffed in the frigid air.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He laughed. “Do you want my coat?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She looked at him and smiled, though her teeth chattered. “No, then "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("you’ll")]), _vm._v(" die. And I’m already wearing one. Sort of.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It’s fine.” He took it off and draped it over her shoulders. It smelled good. And it felt good—still warm from his body heat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But now he had to be freezing to death because all he had on was a T-shirt that said "), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PUERTO RICO")]), _vm._v(" and pictured what looked like a cartoon frog. Her Spanish wasn’t good enough to read the rest and get an idea of what the frog had to do with Puerto Rico, but she was pretty sure it didn’t represent magical warming properties.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Maybe we should go back in,” she suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Or we could get in Todd’s car,” he suggested. It was parked right out front and he went and opened the back door of the blue Dodge.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She looked at him dubiously. Oh, God, Todd had probably told him his stupid blow job story and he’d believed it and thought she was an easy mark. “I’m not … you know…”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It’ll just be warmer in there,” he said, like he understood. “That’s all.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She believed him and climbed onto the icy leather seat, then turned to watch him get in and close the door to the tundra outside.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("From there it got easy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They sat in the car and talked until the windows were fogged and neither one of them was wearing the coat anymore. They talked about everything, from what they liked to do in their free time to what they thought about President Reagan (though Erin didn’t really have a strong opinion about him) and everything in between. They agreed on just about everything. Sometimes when she was about to say something, he said the exact same thing, or vice versa.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was just like the way people talked about soul mates, people who were so much like you it was like you’d never been strangers. Not that she was going to start planning a wedding or anything, but he was so comfortable to be around that she didn’t want to stop even though it was getting later and later. She’d known him a couple of hours and already felt like she’d miss him when they went home for the night.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They’d started on opposite sides of the back bench seat, then gradually had moved closer together, but Nate hadn’t tried a thing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She was starting to get frustrated with that.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“So,” she said, deciding it was time to figure out where he stood. “You … don’t have a girlfriend?” Ugh. That was ballsy. What if he did? Then what would she do? Make up a boyfriend from another school? Go on and on about him like Jan Brady’s “George Glass”?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No.” He looked away for a moment and even though it was dark in the car she could tell from the gesture that he was nervous. “You don’t have a boyfriend?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No.” Actually, she’d never had a boyfriend. He’d probably think she was a loser if she said that, though. Other kids had started “going out,” whatever that meant, in sixth grade.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A tense moment passed between them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then he moved closer and reached his hand behind her back to draw her closer to him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Finally")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She closed her eyes and when his lips touched hers she melted against him. It wasn’t her first kiss now, they both knew that, but it was good. Really good. He moved his other hand firmly against her back, drawing her closer, making her feel warm and safe. And when his tongue touched hers, all of the muscles in her body tightened. Her pulse raced. Why hadn’t they been doing this the whole time?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("How long had they wasted the dwindling night, sitting here "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("talking")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He smelled like winter air, leather, and soap. He tasted like … she didn’t even know what he tasted like, he just tasted good. Almost familiar. Whatever it was, she wanted more. She drank him in, not thinking about what would happen next. It was like there wasn’t even a question.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She was with him now.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Now he would always be part of her. She just didn’t know it yet.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb2"
  }, [_vm._v("The next day, Erin slept in, partly because the beer had gone to her throbbing head and made walking around difficult, and partly because it was more fun to roll over in bed and remember kissing Nate over and over again than it was to get out of bed and actually start a day in which she didn’t have any plans.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Eventually, though, she’d had to. And, true to form, the moment she got out of bed, her mother heard her footsteps and asked her to take the trash out to the garage. So Erin hopped gingerly out in bare feet, opened the garage door, tossed the bag into the can, and closed the door, turning around just in time to see a guy walking past on the street, looking at the house.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He had on a hat and winter coat, almost completely obscuring his face, but she’d know those eyes anywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nate Lawson.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Something inside of her thrummed to life and made the blood push through her veins like it was a race.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nate was walking past her house, either to catch a glimpse of her or at least to see where she lived.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The uncertainty, the questions, the hope he would call, and the fear he wouldn’t … all of that wasn’t necessary this time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He felt the same way she did.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She went back inside smiling.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed11cd74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1.vue
// module id = 75
// module chunks = 0